import { useCallback } from 'react';

import useDatafeedAuthEffect from './useDatafeedAuthEffect';
import useDatafeedMessageEffect from './useDatafeedMessageEffect';
import useDatafeedSocket from './useDatafeedSocket';

type BestBidOfferKey =
  | 'company'
  | `orderbook|${string}`
  | 'securities_transaction'
  | 'side_widget'
  | 'fast_order';

const CHANNEL = 'bestBidOffer';

export const useBestBidOfferSender = (symbols: string[]) => {
  const { setChannel } = useDatafeedSocket();
  const stringSymbols = symbols.filter((v, i, a) => a.indexOf(v) === i).join();

  useDatafeedAuthEffect(() => {
    const bestBidOffer = stringSymbols ? stringSymbols.split(',') : [];
    setChannel({ bestBidOffer });
  }, [stringSymbols]);
};

export const useBestBidReceiver = (
  symbols: string[],
  key: BestBidOfferKey,
  onMessage: (bestBidOffer: BestBidOfferResponse) => void,
) => {
  const stringSymbols = symbols.filter((v, i, a) => a.indexOf(v) === i).join();
  const KEY = `${key}:${stringSymbols}`;

  const onReceiveMessage = useCallback(
    async (message: DatafeedMessageChannel) => {
      const { bestBidOffer } = message || {};
      if (
        bestBidOffer &&
        stringSymbols.split(',').includes(bestBidOffer.stockCode)
      ) {
        onMessage(bestBidOffer);
      }
    },
    [stringSymbols, onMessage],
  );

  useDatafeedMessageEffect(CHANNEL, KEY, onReceiveMessage);
};

const useBestBidOffer = (
  symbols: string[],
  key: BestBidOfferKey,
  onMessage: (bestBidOffer: BestBidOfferResponse) => void,
) => {
  useBestBidOfferSender(symbols);
  useBestBidReceiver(symbols, key, onMessage);
};

export default useBestBidOffer;
